import { useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";

import API from "./API";
import { useFetchUserPledges } from "./useFetchUserPledges";

export default function EndPledge({ pledgeID, status, onPledgeEnd, userID }) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const refreshPledgesData = useFetchUserPledges();

  const buttonRef = useRef();

  const shouldCloseConfirmation = () => {
    if (!loading) setShowConfirmation(false);
  };

  const toggleShowConfirmation = () => {
    if (!showConfirmation && !loading) setShowConfirmation(true);
    else shouldCloseConfirmation();
  };

  const handleEndPledgeClick = () => {
    if (loading) return;

    setLoading(true);

    API.endPledge({ pledgeID })
      .post()
      .then(() => {
        setShowConfirmation(false);
        refreshPledgesData(userID);
        if (onPledgeEnd) onPledgeEnd();
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (status !== "active") setShowConfirmation(false);
  }, [status]);

  return (
    <>
      <AnimatePresence>
        {status === "active" && (
          <ButtonWrapper
            key="button"
            animate={{ opacity: 1, scale: 1 }}
            exit={{
              opacity: 0,
              scale: 0.5,
              transition: { type: "tween", duration: 0.2 },
            }}
          >
            <FnrButton
              ref={buttonRef}
              size="small"
              onClick={toggleShowConfirmation}
              forceHover={showConfirmation}
            >
              End Pledge
            </FnrButton>
          </ButtonWrapper>
        )}
      </AnimatePresence>
      <FnrPopover
        show={showConfirmation}
        buttonRef={buttonRef}
        onShouldClose={shouldCloseConfirmation}
        style={{
          backgroundImage:
            "linear-gradient( to right bottom, rgba(180, 37, 45, 0.7), rgba(128, 36, 40, 0.7) )",
        }}
      >
        <ClosePledgeConfirmation>
          Are you sure you want to close this pledge? No more gifts will be able
          to be applied toward this pledge.
          <ClosePledgeButtonHolder>
            <FnrButton
              color="red"
              loading={loading}
              onClick={handleEndPledgeClick}
            >
              End It
            </FnrButton>
          </ClosePledgeButtonHolder>
        </ClosePledgeConfirmation>
      </FnrPopover>
    </>
  );
}
const ButtonWrapper = styled(motion.div)``;
const ClosePledgeConfirmation = styled.div`
  padding: 12px;
  min-width: 240px;
  max-width: 240px;
`;
const ClosePledgeButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;
